const BASE =
  "https://ctshaadi.com/api" ||
  "https://ctshaadi-web.vercel.app/api" ||
  process.env.REACT_APP_API_URL ||
  "http://localhost:5050/api";
const TOKEN_KEY = "cts_token";

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};
export const setToken = (t) => {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* storage unavailable: session-only login */
  }
};

export async function api(path, { method = "GET", body, form } = {}) {
  const token = getToken();
  const headers = {};
  if (body) headers["Content-Type"] = "application/json";
  if (token) headers.Authorization = `Bearer ${token}`;
  let res;
  try {
    res = await fetch(BASE + path, {
      method,
      headers,
      body: form || (body && JSON.stringify(body)),
    });
  } catch {
    throw Object.assign(
      new Error("Cannot reach CTshaadi servers. Check your connection."),
      { status: 0 }
    );
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    if (res.status === 401 && token)
      window.dispatchEvent(new Event("cts:logout"));
    throw Object.assign(new Error(data.message || "Something went wrong"), {
      status: res.status,
      data,
    });
  }
  return data;
}

export const toQuery = (obj) =>
  Object.entries(obj)
    .filter(
      ([, v]) =>
        v !== "" &&
        v !== undefined &&
        v !== null &&
        !(Array.isArray(v) && !v.length) &&
        v !== false
    )
    .map(
      ([k, v]) =>
        `${k}=${encodeURIComponent(Array.isArray(v) ? v.join(",") : v)}`
    )
    .join("&");
